<template>
    <div id="global-uploader">
        <!-- 上传 -->
        <uploader
            ref="uploader"
            :options="options"
            @file-added="onFileAdded"
            @file-success="onFileSuccess"
            @file-progress="onFileProgress"
            @file-error="onFileError"
            class="uploader-app">
            <uploader-list>
                <div class="file-panel" slot-scope="props">
                    <ul class="file-list">
                        <li v-for="file in props.fileList" :key="file.id">
                            <uploader-file  :class="'file_' + file.id" ref="files" :file="file" :list="true">
                                <template slot-scope="scope">
                                    <div>
                                        <span class='fileName'>{{scope.file.name}}</span>
                                        <span class="speedItem" v-if='!(parseInt((scope.file._prevProgress.toFixed(2))*100)==100)'>速度：{{scope.formatedAverageSpeed}}</span>
                                        <span class='bfb'>{{parseInt((scope.file._prevProgress.toFixed(2))*100)}}%</span>
                                    </div>
                                    <el-progress v-if='!(parseInt((scope.file._prevProgress.toFixed(2))*100)==100)' :stroke-width='2' :show-text='false' :percentage="parseInt((file._prevProgress.toFixed(2))*100)" color="#d70a30">
                                    </el-progress>
                                </template>
                            </uploader-file>
                        </li>
                    </ul>
                </div>
            </uploader-list>
            <uploader-btn id="global-uploader-btn" :attrs="attrs" ref="uploadBtn">选择文件</uploader-btn>
        </uploader>
    </div>
</template>

<script>
import SparkMD5 from 'spark-md5'
    export default {
        data() {
            return {
                options: {
                    target:'/api/v2/chunk/chunkUpload',
                    singleFile:true,
                    chunkSize: '2048000',
                    fileParameterName: 'file',
                    //maxChunkRetries: 3,
                    testChunks: false,   //是否开启服务器分片校验
                    // 服务器分片校验函数，秒传及断点续传基础
                    /* checkChunkUploadedByResponse: function (chunk, message) {
                        
                        let objMessage = JSON.parse(message);
                        console.log(objMessage)
                        if (objMessage.skipUpload) {
                            return true;
                        }
                        return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
                    }, */
                    parseTimeRemaining: function (timeRemaining, parsedTimeRemaining) {
                        return parsedTimeRemaining
                            .replace(/\syears?/, '年')
                            .replace(/\days?/, '天')
                            .replace(/\shours?/, '小时')
                            .replace(/\sminutes?/, '分钟')
                            .replace(/\sseconds?/, '秒')
                    },
                    /* processParams(params){
                        return{
                            filename: params.filename,
                            identifier: params.identifier,
                            totalChunks: params.totalChunks,
                            chunkNumber: params.chunkNumber,
                            wjlx:1002
                        }
                    }  */
                },
                attrs: {
                    accept: {
                        document: ['.bjtbwj', '.bfcgtbwj'],
                    }
                },
            }
        },   
        mounted() {
        },
        computed: {
            //Uploader实例
            uploader() {
                return this.$refs.uploader.uploader;
            }
        },
        methods: {
            onFileAdded(file) {
                this.$emit('fileAdded')
                this.computeMD5(file);
            },
            onFileProgress(rootFile, file, chunk) {
                console.log(`上传中 ${file.name}，chunk：${chunk.startByte / 1024 / 1024} ~ ${chunk.endByte / 1024 / 1024}`)
            },
            onFileSuccess(rootFile, file, response, chunk) {
                let res = JSON.parse(response);
                console.log(res)
                // 服务器自定义的错误（即虽返回200，但是是错误的情况），这种错误是Uploader无法拦截的
                if (res.code==400) {
                    this.$message({ message: res.message, type: 'error' });
                    return
                } 
                // 如果服务端返回需要合并
                if (res.needMerge) {
                    /* this.$api.mergeSimpleUpload({
                        tempName: res.tempName,
                        fileName: file.name,
                        ...this.params,
                    }).then(res => {
                        // 文件合并成功
                        this.$emit('fileSuccess');
                    }).catch(e => {}); */
                // 不需要合并
                } else {
                    this.$emit('fileSuccess',res.model);
                    this.$message({type:'success',message:'上传成功'})
                }
            },
            onFileError(rootFile, file, response, chunk) {
                this.$message({
                    message: response,
                    type: 'error'
                })
            },
            /**
             * 计算md5，实现断点续传及秒传
             * @param file
             */
             computeMD5(file) {
                let fileReader = new FileReader();
                let time = new Date().getTime();
                let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
                let currentChunk = 0;
                const chunkSize = 10 * 1024 * 1000;
                let chunks = Math.ceil(file.size / chunkSize);
                let spark = new SparkMD5.ArrayBuffer();
                file.pause();
                loadNext();
                fileReader.onload = (e => {
                    spark.append(e.target.result);
                    if (currentChunk < chunks) {
                        currentChunk++;
                        loadNext();
                        // 实时展示MD5的计算进度
                        /* this.$nextTick(() => {
                            $(`.myStatus_${file.id}`).text('校验MD5 '+ ((currentChunk/chunks)*100).toFixed(0)+'%')
                        }) */
                    } else {
                        let md5 = spark.end();
                        this.computeMD5Success(md5, file);
                        console.log(`MD5计算完毕：${file.name} \nMD5：${md5} \n分片：${chunks} 大小:${file.size} 用时：${new Date().getTime() - time} ms`);
                    }
                });
                fileReader.onerror = function () {
                    this.error(`文件${file.name}读取出错，请检查该文件`)
                    file.cancel();
                };
                function loadNext() {
                    let start = currentChunk * chunkSize;
                    let end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;
                    fileReader.readAsArrayBuffer(blobSlice.call(file.file, start, end));
                }
            },
            computeMD5Success(md5, file) {
                // 将自定义参数直接加载uploader实例的opts上
                Object.assign(this.uploader.opts, {
                    query: {
                        ...this.params,
                    }
                })
                file.uniqueIdentifier = md5;
                file.resume();
            }, 
            error(msg) {
                this.$notify({
                    title: '错误',
                    message: msg,
                    type: 'error',
                    duration: 2000
                })
            }
        },
        watch: {},
        destroyed() {},
    }
</script>

<style scoped lang="scss">
    #global-uploader {
        .uploader-list{
            height: 49px;
            width: 80%;
            background-color: #f2f2f2;
            border: 1px solid #e2e2e2;
            border-radius: 5px;
            float: left;
            margin-right:10px;
            .uploader-file{
                border:none;
                position: relative;
            }
        }
        .uploader-btn{
            width:80px;
            height:36px;
            line-height:36px;
            font-size: 14px;
            background:#d70a30;
            text-align: center;
            padding:0;
            border:none;
            color:#fff;
            margin-top:7px;
        }
        .uploader-btn:hover{
            background:#df3b59;
        }
        .fileName{
            width:65%;
            display: block;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            word-break: break-all;
            float: left;
            margin-left:10px;
        }
        .speedItem,.bfb{
            margin-left:20px;
        }
        .el-progress{
            border-radius: 10px;
            position: absolute;
            left:0;
            bottom:0;
            width: 100%;
            z-index: 1;
        }
    }
    
</style>